import { AccountType } from './account';

export const COMMON_ACCOUNT_PROVIDERS = {
  [AccountType.CASH]: {
    name: 'Caisse',
    backgroundColor: '#21A950',
  },
  [AccountType.MOBILE]: {
    name: 'Mobile',
    backgroundColor: '#FFBD3D',
  },
};
